import { Button, Stack, Typography } from '@mui/material'
import { useFiltros } from '../state/FiltrosContext'

/**
 * Estado vazio de gráfico/tabela — texto claro + atalho de período opcional.
 */
export function ChartEmpty({
  title,
  hint,
  suggestPeriod = true,
  dense = false,
}: {
  title: string
  /** Contexto extra; sem ele, aparece a dica padrão quando suggestPeriod está ligado. */
  hint?: string
  /** Mostra «Últimos 7 dias» quando o filtro atual é curto (hoje / esta semana / este mês). */
  suggestPeriod?: boolean
  dense?: boolean
}) {
  const { periodo, setPeriodo, customRange } = useFiltros()
  const showCta =
    suggestPeriod && !customRange && (periodo === 'hoje' || periodo === 'semana' || periodo === 'mes')
  const resolvedHint =
    hint ??
    (showCta
      ? 'Pode ser o filtro de período — tente Últimos 7 dias.'
      : suggestPeriod
        ? 'Amplie o período ou volte para todas as marcas no topo.'
        : undefined)

  return (
    <Stack
      spacing={1}
      alignItems="center"
      justifyContent="center"
      sx={{
        pt: dense ? 4 : 8,
        px: 2,
        textAlign: 'center',
        minHeight: dense ? 120 : undefined,
      }}
    >
      <Typography color="text.secondary" sx={{ fontWeight: 600, maxWidth: 360 }}>
        {title}
      </Typography>
      {resolvedHint ? (
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360, opacity: 0.9 }}>
          {resolvedHint}
        </Typography>
      ) : null}
      {showCta ? (
        <Button
          size="small"
          variant="outlined"
          onClick={() => setPeriodo('7d')}
          sx={{ textTransform: 'none', fontWeight: 700, mt: 0.5 }}
        >
          Últimos 7 dias
        </Button>
      ) : null}
    </Stack>
  )
}
